/**
 * Blog page script
 * 
 * @author HammersportMarketing
 */

 import "../../sass/blog.scss";
 import AWN from "awesome-notifications";

 $("form.newsletter").on("submit", (e) => {
    e.preventDefault();
    const formData = {
      email: $("form.newsletter").find("input[name='email']").val(),
    };
    $("ul.error-list").empty();
    // Create new promise to handle notifications with awesome-notifications
    const promise = $.ajax({
      url: global_vars.ajaxurl,
      type: "POST",
      data: {
        action: "hsm_send_newsletter_form",
        security: theme_vars.newsletter_ajax_nonce,
        form: JSON.stringify(formData),
      },
    });
    // Handle response behavior with awesome-notifications
    let notifier = new AWN();
    notifier.asyncBlock(
      promise,
      // On success
      function (response) {
        const errors = response.data;
        // Check for errors
        if (errors.length <= 0) {
          // Handle ajax success
          notifier.success("You are now in our subscription list!");
        } else {
          notifier.alert(
            "Woops, there's something wrong. Please check your info and try again"
          );
        }
      },
      // On reject
      function (response) {
        notifier.alert("Something went wrong, please try again later");
      }
    );
  });